import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { saveBreakdownPayload } from 'store/entities/payroll/payrollSetup/action';
import ReactToolTip from 'react-tooltip';
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as DeleteIcon } from "assets/images/icons/project-icons/trash.svg";
import { useRef } from 'react';

    const SalaryBreakdownTab = ({breakdownSubmitRef, form, setForm, setCurrent}) => {
    const dispatch = useDispatch();
    const customSubmitref = useRef()
    const [totalPercent, setTotalPercent] = useState(0);

    const percentValid = totalPercent === 100
    const customItemsValid = form?.salary_breakdown?.filter((item) => item.is_default === false)?.length > 0

    const updateCustom = (e, id) => {
    const name = e.target.name
    const value = e.target.value
    const actual = form?.salary_breakdown?.map(item => item.id === id ? {...item, [name]: value} : item)
    setForm({...form, salary_breakdown: actual})
    }

    const submitDefault = (e) => {
        e.preventDefault()
        const emptyItem = form?.salary_breakdown?.find((item) => !item?.salary_component?.length || !item.percentage?.length)
        const result = form?.salary_breakdown?.reduce((acc, item) => acc + Number(item.percentage), 0);
        setTotalPercent(result)


        if(emptyItem) {
            toast.error('Please fill or delete empty fields')
        } else if(result !== 100) {
            toast.error('Total salary breakdown must be 100%')
        } else {
            const totalPayload = {
                ...form,
                country_code: 'NG',
                salary_breakdown: form?.salary_breakdown?.map((item) => ({salary_component: item.salary_component, percentage: Number(item.percentage), is_default: item.is_default}))
            }
            customSubmitref?.current?.click();
            dispatch(saveBreakdownPayload(totalPayload))
            setCurrent(1)
        }
    }

        const deleteCustomItem = (id) => {
            const filtered = form?.salary_breakdown?.filter(item => item.id !== id)
            setForm({...form, salary_breakdown: filtered})
        }

        useEffect(() => {
            const result = form?.salary_breakdown?.reduce((acc, item) => acc + Number(item.percentage), 0)
            setTotalPercent(result)
        }, [form?.salary_breakdown])

    return (
        <div>
            <form onSubmit={submitDefault}>
                <div className="structure-wrap">
                    <p className="structure-text">Default Items</p>
                    <div className="structure-input bg-white p-5 pb-0">
                        {form?.salary_breakdown?.filter((item) => item.is_default === true)?.map(({id, salary_component, percentage}) => (
                            <div key={id} className="flex items-center mb-5">
                                <div className='w-2/4 mr-3'>
                                    <input className="structure-form-input rounded-sm capitalize" disabled type="text" placeholder={salary_component?.toLowerCase()} />
                                </div>

                                <div className="relative w-2/4">
                                    <input
                                        required
                                        name="percentage"
                                        className="form-input"
                                        type="number" id='prl-input'
                                        value={percentage || ""}
                                        onChange={(e) => updateCustom(e, id)} />
                                    <div className="absolute bottom-0 right-0 border border-l h-full w-12 flex items-center justify-center rounded-sm p-2">%</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <button ref={breakdownSubmitRef} style={{display: 'none'}} type="submit">Continue</button>
            </form>

            <hr className="w-full" />

                <div className="w-full py-4">
                    <div className="structure-wrap">
                        <p className="structure-text">Custom Items</p>
                        <div className="structure-input">

                            <Maybe condition={customItemsValid}>
                                <div className="bg-white w-full p-5 pb-0 border">
                                    {form?.salary_breakdown?.filter((item) => item.is_default === false)?.map(({id, salary_component, percentage}) => (
                                            <div key={id} className="flex items-center justify-between space-x-3 mb-5">
                                                <div className='w-full'>
                                                    <input
                                                        required
                                                        name='salary_component'
                                                        className="structure-form-input rounded-sm capitalize"
                                                        type="text"
                                                        value={salary_component || ""}
                                                        placeholder={salary_component?.toLowerCase()}
                                                        onChange={(e) => updateCustom(e, id)}
                                                    />
                                                </div>

                                                <div className="relative w-full">
                                                    <input
                                                        required
                                                        name="percentage"
                                                        className="form-input"
                                                        type="number" id='prl-input'
                                                        value={percentage || ""}
                                                        onChange={(e) => updateCustom(e, id)}
                                                    />
                                                    <div className="absolute bottom-0 right-0 border border-l h-full w-12 flex items-center justify-center rounded-sm p-2">%</div>
                                                </div>

                                                <div className="ml-3">
                                                    <DeleteIcon onClick={() => deleteCustomItem(id)} className="ml-1 cursor-pointer"/>
                                                </div>
                                            </div>
                                    ))}
                                </div>
                            </Maybe>

                                <div className="w-full border-b pb-8">
                                    <button onClick={() => {
                                        setForm({...form, salary_breakdown: [...form?.salary_breakdown, {id: Math.random(), is_default: false, salary_component: "", percentage: 0}]})
                                    }} className="mt-4 text-ep-primary-600">
                                        + Add item
                                    </button>
                                </div>

                                <div className="w-full flex-btw bg-gray-300 rounded-md p-3 mt-5">
                                    <p className="mb-0 text-xs">
                                        Total Salary Breakdown is <span className={`font-semibold ${percentValid ? "text-ep-primary-400" : "text-red-500"}`}>{totalPercent}%</span>
                                    </p>
                                    <ReactToolTip  id='info-totalBreakdown'>Salary breakdown should sum up to 100%</ReactToolTip>
                                    <label data-tip data-for='info-totalBreakdown'>
                                        <FontAwesomeIcon icon='question-circle' className=''/>
                                    </label>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
    )
}

export default SalaryBreakdownTab